import React, { useState } from "react";
import { Container, Card, TextField, Button, Typography, Box, CircularProgress } from "@mui/material";
import OTPInput from "./Otp"; // Import the OTPInput component
import axios from "../Axiosinstance";
import logopng from "../images/logopng.png";

export default function Home() {
  const [showOTPInput, setShowOTPInput] = useState(false);
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleGetCodeClick = async () => {
    if (!email) {
      setError("Please enter your email");
      return;
    }
    if (!validateEmail(email)) {
      setError("Please enter a valid email address");
      return;
    }

    try {
      setLoading(true);
      const response = await axios.post("request-otp", { email });
      if (response.status === 200) {
        setShowOTPInput(true);
      }
    } catch (error) {
      console.error("Error requesting OTP:", error);
      setError("Failed to send OTP. Try again.");
    } finally {
      setLoading(false);
    }
  };

  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
      }}
    >
      <Card
        sx={{
          borderRadius: 3,
          p: 3,
          boxShadow: 3,
          width: "100%",
          textAlign: "center",
        }}
      >
        {/* Logo */}
        <Box sx={{ display: "flex", justifyContent: "center", mb: 3 }}>
          <img src={logopng} alt="Logo" width={120} />
        </Box>

        {showOTPInput ? (
          <OTPInput email={email} />
        ) : (
          <Box>
            <Typography variant="h6" gutterBottom>
              Forgot Password
            </Typography>
            <TextField
              fullWidth
              label="Enter Email ID"
              variant="outlined"
              error={!!error}
              helperText={error}
              value={email}
              onChange={(e) => {
                setEmail(e.target.value);
                setError(""); // Clear error when typing
              }}
              sx={{ mb: 2 }}
            />
            <Button
              fullWidth
              variant="contained"
              color="primary"
              onClick={handleGetCodeClick}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} sx={{ color: "white" }} /> : "Get Code"}
            </Button>

            <Typography variant="caption" display="block" sx={{ mt: 2, color: "gray", textAlign: "right" }}>
              Powered by LIDER Technology
            </Typography>
          </Box>
        )}
      </Card>
    </Container>
  );
}
